<script setup>
import { computed } from 'vue'
import Icon from './Icon.vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  isSearching: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'Search',
  },
  variant: {
    type: String,
    default: 'mobile',
    validator: (value) => ['desktop', 'mobile'].includes(value),
  },
})

const emit = defineEmits(['search'])

const buttonClass = computed(() => {
  const variantClass = props.variant === 'desktop'
    ? 'w-[48px] h-[48px] rounded-full flex items-center justify-center'
    : 'w-full px-6 py-3 rounded-full text-lg font-semibold'

  const stateClass = props.disabled
    ? (props.variant === 'desktop'
      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
      : 'bg-gray-50 text-gray-400 cursor-not-allowed')
    : 'bg-[#4ECF84] text-white hover:bg-[#5bc49a] cursor-pointer'

  return [
    'tripfinder-search-action-button transition-colors',
    variantClass,
    stateClass,
  ]
})

const ariaLabel = computed(() => {
  if (props.variant !== 'desktop') {
    return undefined
  }

  return props.isSearching ? 'Searching' : props.label
})
</script>

<template>
  <button
    :aria-label="ariaLabel"
    :class="buttonClass"
    :disabled="disabled"
    @click="emit('search')"
  >
    <template v-if="variant === 'mobile'">
      {{ label }}
    </template>
    <template v-else>
      <Icon
        v-if="isSearching"
        name="loader"
        size="md"
        class="animate-spin"
      />
      <Icon
        v-else
        name="binoculars"
        size="md"
      />
    </template>
  </button>
</template>
